import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { configureAmplify } from '../config/aws.config';
import { LookupService } from '../services/lookup.service';
import { SingleResultApiResponse } from '../models/api-response.model';
import { AWSSettings } from '../models/aws-settings.model';

@Component({
  selector: 'online-app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit, OnDestroy {

  showNotification: boolean;
  notificationMessage: string;
  phase1Decommissioned: boolean;

  constructor(private router: Router,
    private lookupService: LookupService,
    private renderer: Renderer2,) {
    this.renderer.addClass(document.body, 'login-screen');
   }

  ngOnInit() {
    this.lookupService.getAWSAuthSettings(false)
    .subscribe( (response: SingleResultApiResponse) => {
      if (response.Result) {

        const awsSettings: AWSSettings = {
          Region: response.Result.Region,
          UserPoolId:  response.Result.UserPoolId,
          UserPoolWebClientId:  response.Result.UserPoolWebClientId,
          IdentityPoolId:  response.Result.IdentityPoolId,
          AuthenticationFlowType: response.Result.AuthenticationFlowType,
          BucketName: response.Result.BucketName
        };

        localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

        configureAmplify(false);
      }
    }, err => {
      console.log('error happened while calling AWS Auth Settings');
    });

    this.lookupService.getNotificationSettings(1)
      .subscribe((response: SingleResultApiResponse) => {       
        if (response.Result) {
          this.showNotification = response.Result.Item1;
          this.notificationMessage = response.Result.Item2;
          this.phase1Decommissioned = response.Result.Item3;
        }
      }, err => {
        console.log('error happened while calling Notification Settings');
      });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'login-screen');
  }

  signIn(): void {

    localStorage.clear();

    this.lookupService.getAWSAuthSettings(false)
        .subscribe( (response: SingleResultApiResponse) => {

          if (response.Result) {

            const awsSettings: AWSSettings = {
              Region: response.Result.Region,
              UserPoolId:  response.Result.UserPoolId,
              UserPoolWebClientId:  response.Result.UserPoolWebClientId,
              IdentityPoolId:  response.Result.IdentityPoolId,
              AuthenticationFlowType: response.Result.AuthenticationFlowType,
              BucketName: response.Result.BucketName
            };

            localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

            configureAmplify(false);
            this.router.navigate(['/login']);
          }

        }, err => {
          console.log('error happened while calling AWS Auth Settings');
        }, () => {
         });

  }

  register(): void {
    localStorage.clear();
    this.lookupService.getAWSAuthSettings(false)
        .subscribe( (response: SingleResultApiResponse) => {

          if (response.Result) {

            const awsSettings: AWSSettings = {
              Region: response.Result.Region,
              UserPoolId:  response.Result.UserPoolId,
              UserPoolWebClientId:  response.Result.UserPoolWebClientId,
              IdentityPoolId:  response.Result.IdentityPoolId,
              AuthenticationFlowType: response.Result.AuthenticationFlowType,
              BucketName: response.Result.BucketName
            };

            localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

            configureAmplify(false);
            this.router.navigate(['pre-registration']);
          }

        }, err => {
          console.log('error happened while calling AWS Auth Settings');
        }, () => {
        });

  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }

}
